<template>
	<div
		class="multi-format-graphic-selector"
		:aria-label="$I18n.trans('event.multiformat_editor.labels.branding')"
	>
		<button
			v-for="option in options"
			:key="option.value ?? 'none'"
			type="button"
			class="multi-format-graphic-selector__option"
			:class="{ 'is-active': option.value === value }"
			:aria-pressed="option.value === value ? 'true' : 'false'"
			:title="option.label"
			@click="$emit('change', option.value)"
		>
			<span class="multi-format-graphic-selector__label">
				{{ option.label }}
			</span>
			<span
				v-if="option.aspectRatio"
				class="multi-format-graphic-selector__aspect-ratio"
			>
				{{ option.aspectRatio }}
			</span>
		</button>
	</div>
</template>

<script>
export default {
	name:  'MultiFormatGraphicSelector',
	props: {
		value: {
			type:    [String, Number],
			default: null,
		},
		options: {
			type:    Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.multi-format-graphic-selector {
	display: flex;
	flex-direction: column;
	gap: $sp3;
	width: 100%;
}

.multi-format-graphic-selector__option {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: $sp3;
	width: 100%;
	min-height: 44px;
	padding: $sp3 $sp4;
	border: 1px solid var(--color-grey-600);
	border-radius: $border-radius--sm;
	overflow: hidden;
	color: var(--color-white);
	background-color: rgba($color-white, 0.04);
	cursor: pointer;
	transition: border-color $trans-time-fast, background-color $trans-time-fast, color $trans-time-fast;

	&:hover,
	&:focus {
		border-color: var(--color-grey-400);
		background-color: rgba($color-white, 0.08);
	}

	&.is-active {
		border-color: var(--color-hype-yellow);
		background-color: rgba($color-hype-yellow, 0.12);
	}
}

// stylelint-disable selector-max-type, selector-no-qualifying-type
body.-t-light {
	.multi-format-graphic-selector__option {
		color: var(--color-black);
		background-color: var(--color-grey-100);

		&:hover,
		&:focus {
			border-color: var(--color-grey-700);
			background-color: var(--color-white);
		}
	}
}
// stylelint-enable selector-max-type, selector-no-qualifying-type

.multi-format-graphic-selector__label {
	@include font-size(fs-60);
	display: block;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.multi-format-graphic-selector__aspect-ratio {
	@include font-size(fs-60);
	flex-shrink: 0;
	color: var(--color-grey-400);
}

</style>
